import React from 'react';
import { Pane, Heading, Paragraph } from 'evergreen-ui';
import StyledLogo from 'components/shared/Layout/MuruLogo';

// Maintenance window: 2026-04-10 05:00–06:00 EDT (09:00–10:00 UTC)
const MAINTENANCE_START = new Date('2026-04-10T09:00:00Z');
const MAINTENANCE_END = new Date('2026-04-10T10:00:00Z');

export function isMaintenanceActive(): boolean {
  return false;
}

function MaintenancePage() {
  return (
    <Pane
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      padding={32}
      textAlign="center"
    >
      <StyledLogo />
      <Heading size={700} marginTop={24} marginBottom={16}>
        Scheduled Maintenance
      </Heading>
      <Paragraph size={500} color="muted" maxWidth={480}>
        Muru is undergoing maintenance
        <br />
        from{' '}
        {MAINTENANCE_START.toLocaleTimeString([], {
          hour: 'numeric',
          minute: '2-digit',
        })}{' '}
        &ndash;{' '}
        {MAINTENANCE_END.toLocaleTimeString([], {
          hour: 'numeric',
          minute: '2-digit',
        })}
        .<br />
        We&apos;ll be back shortly.
      </Paragraph>
    </Pane>
  );
}

export default MaintenancePage;
